import { UserOutlined } from '@ant-design/icons';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import ContactDetailsForm from './ContactDetailsForm';
import ContactDetailsView from './ContactDetailsView';

type Props = {
    isEditing: boolean;
};

const ContactDetails = ({ isEditing }: Props) => {
    const content = isEditing ? <ContactDetailsForm /> : <ContactDetailsView />;

    return (
        <CardWithIcon
            title="Contact Details"
            gap="large"
            iconProps={{
                icon: <UserOutlined />,
                status: 'success',
            }}
            bordered={false}
            children={<div style={{ marginTop: 24 }}>{content}</div>}
        />
    );
};

export default ContactDetails;
